<template>
  <!-- 公司信息 -->
  <div class="gsxx">
    <el-backtop></el-backtop>
    <div class="gsxx_header">
      <img
        style="width: 100%; height: 100%"
        src="../assets/cp/gsjj.png"
        alt=""
      />
    </div>
    <div class="gsjj">
      <div style="
          margin-top: 20px;
          margin-left: 20%;
          color: #d3d3d3;
          cursor: pointer;
        ">
        <span @click="tiaozhuan()">首页></span>
        <span style="color: black">公司简介</span>
      </div>
      <div
        class="bt"
        id="top1"
      >
        <span>公司简介</span>
        <p>COMPANY PROFILE</p>
      </div>
      <div class="content">
        <p style="text-indent: 2em">
          北京点奈特医疗科技有限公司成立于2021 年 2 月 26 日，是一家扎根北京、专注于医疗数字化与智能诊疗技术的科技研发企业。公司以虚拟仿真、人工智能、动作捕捉、图像识别为核心技术底座，深度融合临床医学需求，聚焦AI 辅助诊断、智能康复评估、医疗虚拟仿真、儿科罕见病管理等方向，为医院、科室、患者及家庭提供全流程、可落地、高临床价值的数字化解决方案。
        </p>
      </div>
    </div>
    <div
      class="gsgc wow fadeInUp"
      data-wow-duration=".5s"
      id="top2"
    >
      <div class="bt">
        <span>组织结构</span>
        <p>ORGANIZATION STRUCTURE</p>
      </div>

      <div class="card">
        <img
          height="450px"
          src="../assets/zzjg.png"
          alt=""
        />
      </div>
    </div>
    <div
      class="ywfw wow fadeInUp"
      data-wow-duration=".5s"
    >
      <div class="bt">
        <span>“儿科疾病辅助诊疗系统”APP功能简介</span>
        <p>Introduction to Mobile Features</p>
      </div>
      <!-- 上半部分：首页手机截图 + APP总体介绍 -->
      <div class="app-intro">
        <div class="app-phone-wrap">
          <img
            class="app-phone-img"
            src="../assets/qietu/sy.png"
            alt="APP首页"
          />
          <p class="app-phone-label">首页</p>
        </div>
        <div class="app-intro-text">
          <h2 class="app-intro-title">幼年皮肌炎AI辅助诊疗平台 V1.5.0（小儿科.net）</h2>
          <div class="app-intro-desc">
            <p>2019 年，在李建国主任的启发与专业指导下，依托公司自主研发的中医智能诊疗技术，公司开始了幼年皮肌炎 AI 辅助诊疗平台系统的研发；</p>
            <p>该平台是面向幼年皮肌炎患儿打造的全周期一站式智能管理系统，覆盖院前早期筛查、院中精准诊疗、院后长期康复全流程场景；</p>
            <p>平台深度融合 AI 大模型智能分析、专科化医疗服务、全病程数据管理及个性化专属关怀功能，精准解决幼年皮肌炎早期筛查困难、病程管理不规范、康复指导不足等行业痛点，构建起覆盖 “筛查 — 诊疗 — 康复” 的全流程智能化服务闭环，显著提升疾病诊疗效率与康复管理水平；</p>
            <p>平台同时面向患儿家长与临床医师两大核心群体，搭建家长端与医生端双端口协同体系，实现医患联动、全程可及、规范管理的一体化服务。</p>
          </div>
        </div>
      </div>

      <!-- 中部：6个功能Tab切换（带图标+名称+下划线）+ 选中放大+3秒自动切换 -->
      <div class="app-tabs">
        <div
          class="app-tab-item"
          :class="{ 'is-active': activeTab === idx }"
          v-for="(tab, idx) in appTabList"
          :key="tab.key"
          @click="handleTabClick(idx)"
        >
          <img
            class="tab-icon"
            :src="activeTab === idx ? tab.iconActive : tab.icon"
            :alt="tab.name"
          />
          <p
            class="tab-name"
            :class="{ 'tab-name-active': activeTab === idx }"
          >
            {{ tab.name }}
          </p>
          <div
            class="tab-underline"
            v-if="activeTab === idx"
          ></div>
        </div>
      </div>

      <!-- 下半部分：当前选中功能手机截图 + 对应文字说明 -->
      <div class="app-feature">
        <div class="feature-phone-wrap">
          <img
            class="feature-phone-img"
            :src="appTabList[activeTab].phone"
            :alt="appTabList[activeTab].name"
          />
        </div>
        <div class="feature-text-wrap">
          <h2 class="feature-title">{{ appTabList[activeTab].name }}</h2>
          <div class="feature-desc">
            <p
              v-for="(para, i) in appTabList[activeTab].descs"
              :key="i"
            >
              {{ para }}
            </p>
          </div>
        </div>
      </div>

      <div class="bt">
        <span>成果展示</span>
        <p>INTELLECTUAL PROPERTY</p>
      </div>
      <div class="carousel-container">
        <el-carousel
          :interval="5000"
          type="card"
          height="600px"
          arrow="always"
          indicator-position="outside"
          @change="handleCarouselChange"
        >
          <el-carousel-item
            v-for="(item, index) in carouselData"
            :key="index"
          >
            <div class="carousel-item">
              <img
                :src="item.image"
                :alt="item.title"
              />
              <div class="carousel-text">
                <h3>{{ item.title }}</h3>
                <p>{{ item.description }}</p>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <Contact></Contact>
    </div>
  </div>
</template>
<script>
import WOW from "wowjs";
import Contact from "../components/ContactUs.vue";
import { selectbrief } from "@/api/patient.js";
export default {
  components: { Contact },
  name: "Home",
  data() {
    return {
      form: {
        name: "",
        region: "",
        desc: "",
      },
      // APP功能6个Tab，默认选中第3个（电子病历管理），index从0开始
      activeTab: 2,
      // 自动切换Tab的定时器句柄（用于3秒轮播，组件销毁/用户点击时幂等重置）
      autoTimer: null,
      // Tab自动轮播间隔：3000ms = 3秒
      AUTO_INTERVAL: 3000,
      appTabList: [
        {
          key: "pjysc",
          name: "皮肌炎AI筛查",
          icon: require("../assets/qietu/pjysc.png"),
          iconActive: require("../assets/qietu/pjysc1.png"),
          phone: require("../assets/qietu/pjysct.png"),
          descs: [
            "本项目依托多模态图像识别与人体运动量化算法，提供幼年皮肌炎线上无创初筛。用户上传皮疹图像、运动视频，AI提取体征输出量化评分，经医生复核判定疑似风险，提示高风险患儿专科就诊，实现早筛预警，改善基层漏诊、主观判断的问题。",
          ],
        },
        {
          key: "dzblgl",
          name: "电子病历管理",
          icon: require("../assets/qietu/dzblgl.png"),
          iconActive: require("../assets/qietu/dzblgl1.png"),
          phone: require("../assets/qietu/dzblglt.png"),
          descs: [
            "系统实现电子病历数字化管理，归集皮疹图像、运动视频、用药、诊断记录形成患儿电子档案。基于历次AI筛查得分生成病情趋势图，医生查阅病历及筛查结果，出具个性化诊疗建议，实现病程动态追踪，支撑幼年皮肌炎慢病随访。",
          ],
        },
        {
          key: "jkgl",
          name: "健康管理",
          icon: require("../assets/qietu/jkgl.png"),
          iconActive: require("../assets/qietu/jkgl1.png"),
          phone: require("../assets/qietu/jkglt.png"),
          descs: [
            "健康管理模块完成患儿健康数据建档与动态管理。用户录入身高体重、BMI、血压、血糖、尿酸、视力等指标，系统对照同龄标准展示发育情况；可归档既往史、家族史、过敏信息，记录用药并提供服药提醒，支持体检报告上传，数据统一可追溯，为医生随访诊疗提供数据支撑。",
          ],
        },
        {
          key: "pjykp",
          name: "皮肌炎科普",
          icon: require("../assets/qietu/pjykp.png"),
          iconActive: require("../assets/qietu/pjykp1.png"),
          phone: require("../assets/qietu/pjykpt.png"),
          descs: [
            "皮肌炎科普模块提供图文、视频形式的疾病科普内容，所有科普文章均由平台认证审核的执业医生发布，向用户普及幼年皮肌炎相关知识，帮助家长提升疾病认知，做好日常识别与家庭健康照护。",
          ],
        },
        {
          key: "pysc",
          name: "皮炎AI筛查",
          icon: require("../assets/qietu/pysc.png"),
          iconActive: require("../assets/qietu/pysc1.png"),
          phone: require("../assets/qietu/pysct.png"),
          descs: [
            "皮炎AI筛查模块支持用户上传皮炎皮损图像，由AI 对皮损特征开展智能分析，给出皮损情况研判及相似疾病参考提示，帮助用户初步识别皮肤异常表现，为后续就医提供参考。",
          ],
        },

        {
          key: "jwlsc",
          name: "肌无力AI筛查",
          icon: require("../assets/qietu/jwlsc.png"),
          iconActive: require("../assets/qietu/jwlsc1.png"),
          phone: require("../assets/qietu/jwlsct.png"),
          descs: [
            "肌无力AI筛查模块，支持用户上传肢体运动视频，AI 提取运动特征智能分析评估肌无力等级，完成体征初步研判，为医生评估患儿肌肉受累情况提供参考依据。",
          ],
        },
      ],
      GCData: [],
      jjData: [],
      zjData: [],
      carouselData: [
        {
          image: require("../assets/gy/1.png"),
          title: "CCF A 类期刊",
          description:
            "2025 年，依托本项目成果，在IEEE Transactions on Visualization and Computer Graphics（TVCG） 国际顶级期刊发表学术论文，该期刊为CCF A类、SCI 收录期刊；",
        },
        {
          image: require("../assets/gy/2.png"),
          title: "科技查询报告 ",
          description:
            "2026年1月，提交申请技术查新，经中科院文献情报中心审批本平台国内首创、技术领先，填补幼年皮肌炎 AI 辅助诊疗空白；",
        },
        {
          image: require("../assets/gy/3.png"),
          title: "儿科疾病辅助诊断系统 V1.0 ",
          description:
            "通过人工智能算法对异常运动、皮疹图片的结合识别，按照CMAS 评分体系进行打分，对高危用户进行预警；",
        },
        {
          image: require("../assets/gy/4.png"),
          title: "北京市医院管理中心第六届科技创新大赛",
          description:
            "2023 年 4 月，首都医科大学附属北京儿童医学中心风湿免疫科王欣宁副主任医师团队，依托本项目参加北京市医院管理中心第六届科技创新大赛各项目经院内遴选、初赛初评、复赛审议，最终 10 个项目晋级决赛；本项目凭借创新性与临床价值脱颖而出，与一等奖仅差0.72分，荣获三等奖。",
        },
      ],
      currentCarouselIndex: 0,
    };
  },

  mounted() {
    this.$router.afterEach((to, from, next) => {
      if (to.params.lx == "公司简介") {
        setTimeout(() => {
          const TOP = document.getElementById("top1");
          const y = TOP.offsetTop;
          window.scrollTo({
            top: y,
            behavior: "smooth",
          });
        }, 1000);
      } else if (to.params.lx == "主要领导介绍") {
        setTimeout(() => {
          const TOP = document.getElementById("top2");
          const y = TOP.offsetTop;
          window.scrollTo({
            top: y,
            behavior: "smooth",
          });
        }, 1000);
      } else if (to.params.lx == "App功能简介") {
        setTimeout(() => {
          window.scrollTo({
            top: 2200,
            behavior: "smooth",
          });
        }, 500);
      } else if (to.params.lx == "成果展示") {
        setTimeout(() => {
          window.scrollTo({
            top: 3000,
            behavior: "smooth",
          });
        }, 500);
      }
    });
    this.getSelectbrief();
    setTimeout(() => {
      let wow = new WOW.WOW({
        boxClass: "wow",
        animateClass: "animated",
        offset: 100,
        mobile: false,
        live: true,
      });
      wow.init();
    }, 200);
    // 启动Tab 3秒自动轮播
    this.startAutoTab();
  },

  // 组件销毁：清除自动轮播定时器，避免内存泄漏和重复执行
  beforeDestroy() {
    this.stopAutoTab();
  },

  methods: {
    handleCarouselChange(index) {
      this.currentCarouselIndex = index;
    },
    //获取专家
    getSelectbrief() {
      let data = new FormData();
      data.append("page", 1);
      data.append("rows", 100);
      data.append("dentity", "专家顾问");
      selectbrief(data).then((res) => {
        this.zjData = res.rows;
      });
    },
    tiaozhuan() {
      this.$router.push("/");
    },
    // ===== Tab自动轮播 & 用户点击切换（统一入口，幂等：先清再建） =====
    // 用户手动点击某个Tab：立即切换 + 重置3秒倒计时（避免点击后立刻又被切走）
    handleTabClick(idx) {
      this.activeTab = idx;
      this.resetAutoTab();
    },
    // 停止自动轮播（clearTimeout并置空句柄，防重复）
    stopAutoTab() {
      if (this.autoTimer) {
        clearTimeout(this.autoTimer);
        this.autoTimer = null;
      }
    },
    // 启动自动轮播（每AUTO_INTERVAL毫秒向后切1个，循环到末尾再回到第0个）
    startAutoTab() {
      // 幂等：启动前先清旧定时器，避免叠加多个轮播
      this.stopAutoTab();
      this.autoTimer = setTimeout(() => {
        const total = this.appTabList ? this.appTabList.length : 6;
        this.activeTab = (this.activeTab + 1) % total;
        // 递归启动下一轮（setTimeout可随时被stop清除，比setInterval更灵活）
        this.startAutoTab();
      }, this.AUTO_INTERVAL);
    },
    // 重置自动轮播（用户点击时调用：停→启，重新计时3秒）
    resetAutoTab() {
      this.stopAutoTab();
      this.startAutoTab();
    },
  },

  watch: {
    "$store.state.rutset": {
      deep: true, //深度监听设置为 true
      handler: function (newVal, oldVal) {
        if (newVal == "公司简介") {
          setTimeout(() => {
            const TOP = document.getElementById("top1");
            const y = TOP.offsetTop;
            window.scrollTo({
              top: y,
              behavior: "smooth",
            });
          });
        } else if (newVal == "主要领导介绍") {
          setTimeout(() => {
            const TOP = document.getElementById("top2");
            const y = TOP.offsetTop;
            window.scrollTo({
              top: y,
              behavior: "smooth",
            });
          });
        }
        // else if (newVal == "专家顾问") {
        //   window.scrollTo({
        //     top: 2200,
        //     behavior: "smooth",
        //   });
        // }
      },
    },
  },
};
</script>
<style scoped>
>>> .el-input__inner {
  height: 60px;
}

>>> .el-carousel__arrow {
  width: 50px;
  height: 50px;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
}

>>> .el-carousel__arrow:hover {
  background-color: rgba(0, 0, 0, 0.8);
}

>>> .el-carousel__indicators--outside {
  margin-top: 20px;
}

>>> .el-carousel__indicator {
  padding: 12px 4px;
}

>>> .el-carousel__button {
  width: 30px;
  height: 3px;
  background-color: #ccc;
  border-radius: 2px;
}

>>> .el-carousel__indicator.is-active .el-carousel__button {
  background-color: #296cbf;
}

>>> .el-carousel--card {
  padding-top: 20px;
}

>>> .el-carousel__item--card {
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

>>> .el-carousel__item--card.is-active {
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.25);
  transform: scale(1.05);
}
</style>
<style lang="scss" scoped>
.gsxx {
  width: 100%;

  .ywfw {
    width: 100%;

    // ---- APP功能简介：上部（首页手机 + 介绍文字） ----
    .app-intro {
      width: 45%; // 原50% → 缩小到45%
      margin: 30px auto 60px;
      display: flex;
      align-items: flex-start;
      justify-content: space-between;

      .app-phone-wrap {
        flex-shrink: 0;
        text-align: center;

        .app-phone-img {
          width: 230px;
          height: auto;
          display: block;
          object-fit: contain;
        }

        .app-phone-label {
          margin-top: 12px;
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #4279e3;
        }
      }

      .app-intro-text {
        flex: 1;
        margin-left: 80px;

        .app-intro-title {
          margin: 0 0 30px;
          font-size: 22px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #4279e3;
          line-height: 1.4;
        }

        .app-intro-desc {
          p {
            margin: 0 0 18px;
            font-size: 15px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #666666;
            line-height: 28px;
            text-align: justify;
          }

          p:last-child {
            margin-bottom: 0;
          }
        }
      }
    }

    // ---- APP功能简介：中部（6个Tab切换） ----
    .app-tabs {
      width: 60%; // 改回60%，让6个Tab图标排布更宽松
      margin: 0 auto 70px;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;

      .app-tab-item {
        flex: 1;
        text-align: center;
        cursor: pointer;
        position: relative;
        padding-bottom: 8px;
        // 默认和选中状态：图标尺寸、文字、间距都用过渡，平滑切换
        transition: all 0.35s ease;

        .tab-icon {
          width: 100px; // 原90px → 默认图标加大到100px
          height: 100px;
          object-fit: contain;
          display: block;
          margin: 0 auto 10px;
          transition: all 0.35s ease; // 放大缩小带过渡动画
        }

        .tab-name {
          margin: 0;
          font-size: 15px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #999999;
          line-height: 1.4;
          transition: all 0.35s ease;
        }

        .tab-name-active {
          color: #4279e3;
          font-weight: bold;
        }

        .tab-underline {
          width: 20%;
          height: 3px;
          background: #4279e3;
          border-radius: 2px;
          margin: 12px auto 0;
        }
      }

      // 选中的Tab：用transform放大+上浮（不改盒模型尺寸，不挤压下面容器）
      .app-tab-item.is-active {
        // 去掉外层的 translateY，改由 icon 内部的 transform 承载（两个transform写在不同元素会冲突叠加，统一写在一处）

        .tab-icon {
          // 占位尺寸保持 100×100 与默认一致 —— 文档流高度稳定，不挤压下方内容
          width: 100px;
          height: 100px;
          // 100×1.2=120px（保持原选中视觉大小不变）+ 上浮6px；从底部中心放大
          transform: translateY(-6px) scale(1.2);
          transform-origin: 50% 100%;
          filter: drop-shadow(0 4px 12px rgba(66, 121, 227, 0.25));
          // 过渡保持平滑
          transition: transform 0.35s ease, filter 0.35s ease;
        }

        .tab-name {
          font-size: 16px;
          margin-top: 4px;
        }
      }
    }

    // ---- APP功能简介：下部（选中功能手机 + 文字说明） ----
    .app-feature {
      width: 45%; // 原50% → 缩小到45%
      margin: 0 auto 60px;
      display: flex;
      align-items: flex-start;
      justify-content: space-between;

      .feature-phone-wrap {
        flex-shrink: 0;

        .feature-phone-img {
          width: 230px;
          height: auto;
          object-fit: contain;
          display: block;
        }
      }

      .feature-text-wrap {
        flex: 1;
        margin-left: 80px;

        .feature-title {
          margin: 20px 0 30px;
          font-size: 22px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #4279e3;
          line-height: 1.4;
        }

        .feature-desc {
          p {
            margin: 0 0 18px;
            font-size: 15px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #666666;
            line-height: 28px;
            text-align: justify;
          }

          p:last-child {
            margin-bottom: 0;
          }
        }
      }
    }

    .bt {
      padding-top: 70px;
      text-align: center;

      span {
        font-size: 26px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
      }

      p {
        margin-top: 5px;
        margin-bottom: 20px;
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
      }
    }

    .zjgw {
      width: 1160px;
      height: 279px;
      margin: auto;
      margin-top: 50px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px;
      background: #ffffff;
      border-radius: 10px;

      .tx {
        width: 213px;
        height: 279px;
        text-align: center;
      }

      .content {
        width: 921px;
        height: 260px;
        text-align: left;
        line-height: 16px;
      }
    }

    .carousel-container {
      width: 100%;
      max-width: 1800px;
      margin: 50px auto;
      padding: 0 20px;

      .carousel-item {
        width: 100%;
        height: 100%;
        position: relative;
        border-radius: 10px;
        overflow: hidden;
        background: #f5f5f5;

        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
          display: block;
        }

        .carousel-text {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          background: linear-gradient(transparent, rgba(0, 0, 0, 0.8));
          padding: 30px;
          color: white;
          text-align: left;

          h3 {
            font-size: 24px;
            margin: 0 0 10px 0;
            font-family: Microsoft YaHei;
            font-weight: bold;
          }

          p {
            font-size: 16px;
            margin: 0;
            line-height: 1.6;
            font-family: Microsoft YaHei;
            font-weight: 400;
          }
        }
      }
    }
  }

  .gsgc {
    height: 42.5rem;
    // opacity: 0.4;
    background: #0044ce;
    background-image: url(../assets/gy/9436aea7046b33186f82c55968d8659.png);
    background-size: 100%, 100%;
    background-size: cover;
    background-repeat: no-repeat;

    .card {
      display: flex;
      justify-content: center;
      align-items: center;

      .jtcard {
        width: 281px;
        height: 424px;
        background: #ffffff;
        margin-top: 30px !important;
        margin: 50px;
        border-radius: 10px;
        box-shadow: 0px 0px 10px 0px rgba(170, 175, 175, 0.21);

        h3 {
          margin-left: 20px;
          font-size: 20px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #171717;
        }

        p {
          margin-top: -10px;
          margin-left: 20px;
          margin-right: 20px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #676767;
        }
      }
    }

    .bt {
      padding-top: 70px;
      text-align: center;

      span {
        font-size: 26px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #ffffff;
      }

      p {
        margin-top: 5px;
        margin-bottom: 20px;
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
      }
    }
  }

  .gsxx_header {
    width: 100%;
    height: 407px;
    // background-image: url(../assets/gy/cd2522fe6c8b4a866dc3f254fe557baf.png);
    // background-size: 100%, 100%;
    // background-size: contain;
    // background-repeat: no-repeat;
  }

  .content {
    margin: auto;
    width: 1006px;
    // height: 55px;
    margin-bottom: 100px;
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #656565;
    text-align: left;
  }

  .gsjj {
    width: 100%;
    // height: 550px;

    .card {
      display: flex;
      justify-content: center;
      align-items: center;

      .jtcard {
        width: 200px;
        height: 250px;
        margin: 20px;
        border-radius: 10px;
        // box-shadow: 0px 0px 10px 0px rgba(170,175,175,0.21);
        text-align: center;

        h3 {
          font-size: 20px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #171717;
        }

        p {
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #676767;
        }
      }
    }

    .bt {
      padding-top: 70px;
      text-align: center;

      span {
        font-size: 26px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
      }

      p {
        margin-top: 5px;
        margin-bottom: 20px;
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
      }
    }
  }
}
</style>
